<!--==================================
=            AUTOCOMPLETE            =
===================================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Autocomplete</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Search Api</div>
          <div slot="card-body">
            <div>
              <searching-api></searching-api>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom filter on autocomplete</div>
          <div slot="card-body">
            <div>
              <customfilter-autocomplete></customfilter-autocomplete>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Dense</div>
          <div slot="card-body">
            <div>
              <dense-autocomplete></dense-autocomplete>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Slots</div>
          <div slot="card-body">
            <div>
              <slots-autocomplete></slots-autocomplete>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Asynchronous items</div>
          <div slot="card-body">
            <div>
              <asynchronous-auto></asynchronous-auto>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Advanced slots</div>
          <div slot="card-body">
            <div>
              <advanced-autocomplete></advanced-autocomplete>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">State selector</div>
          <div slot="card-body">
            <div>
              <state-autocomplete></state-autocomplete>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";

import AdvancedAutocomplete from "../../components/Forms/Autocomplete/AdvancedAutocomplete.vue";
import AsynchronousAuto from "../../components/Forms/Autocomplete/AsynchronousAuto.vue";
import CustomfilterAutocomplete from "../../components/Forms/Autocomplete/CustomfilterAutocomplete.vue";
import DenseAutocomplete from "../../components/Forms/Autocomplete/DenseAutocomplete.vue";
import SearchingApi from "../../components/Forms/Autocomplete/SearchingApi.vue";
import SlotsAutocomplete from "../../components/Forms/Autocomplete/SlotsAutocomplete.vue";
import StateAutocomplete from "../../components/Forms/Autocomplete/StateAutocomplete.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    AdvancedAutocomplete,
    AsynchronousAuto,
    CustomfilterAutocomplete,
    DenseAutocomplete,
    SearchingApi,
    SlotsAutocomplete,
    StateAutocomplete
  }
};
</script>

<!--====  End of AUTOCOMPLETE  ====-->
